export default "__VITE_ASSET__BtGvji7e__"